import { useAccountStore } from '@/app/modules/account';
import type { Guard } from './interfaces';

export const elephantGuard: Guard = async () => {
  const store = useAccountStore();
  await store.fetch();
  return store.isElephant || '/';
};
